import { getAPI } from "./base";

export async function fetchFinancialReports() {
  try {
    const api = getAPI();
    const response = await api.get("/quarterly_reports");
    if (response.status === 200) {
      return response.data;
    } else {
      console.error(
        "Error fetching Financial Reports data: ",
        response.statusText,
      );
    }
  } catch (error) {
    console.error("Error fetching Financial Reports data: ", error);
  }
}
